import { useQuery } from "@tanstack/react-query";
import { USER_API } from "config";
import { normalizeId } from "utils";
import { budgetKeys } from "queries";
import { BudgetVersions } from "components/dashboard/body/projects/panels/budget/types";
import { useAxios } from "../useAxios";

interface UseBudgetVersionsParams {
  projectId: string | number;
  documentId: string | number;
  enabled?: boolean;
}

export const useBudgetVersions = ({
  projectId,
  documentId,
  enabled = true,
}: UseBudgetVersionsParams) => {
  const axios = useAxios({ allResponse: false });
  const pid = normalizeId(projectId);
  const did = normalizeId(documentId);

  return useQuery<BudgetVersions[]>({
    queryKey: budgetKeys.versions(pid, did),
    queryFn: async () => {
      const response = await axios.get<BudgetVersions[]>(USER_API.getBudgetVersions(pid, did));
      return Array.isArray(response) ? response : response.data || [];
    },
    enabled: enabled && Boolean(projectId) && Boolean(documentId),
  });
};
